import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { filter, startWith, tap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class RoutingTabTitleService {
    private titleService = inject(Title);
    private route = inject(ActivatedRoute);
    private router = inject(Router);
    private translate = inject(TranslateService);

    currentPageTitle$ = new BehaviorSubject<string>('');

    setTitle(newTitle: string): void {
        this.titleService.setTitle(newTitle);
    }

    init(): void {
        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                startWith(true),
                tap(() => {
                    let route = this.route;
                    while (route.firstChild) {
                        route = route.firstChild;
                    }
                    if (route.snapshot.data['title']) {
                        const translation = this.translateTitle('PAGE.TITLE', route.snapshot.data['title']);
                        this.setTitle(translation);
                        this.currentPageTitle$.next(translation);
                    }
                }),
            )
            .subscribe();
    }

    setTranslatedTitle(page: string, type: string, optString = ''): void {
        const newTitle = this.translate.instant(`${page}.${type}`);
        this.setTitle(`${optString}${newTitle}`);
    }

    translateTitle(page: string, type?: string): string {
        if (!type) {
            return this.translate.instant(`${page}`);
        } else {
            return this.translate.instant(`${page}.${type}`);
        }
    }

    translateSeoDescription(page: string, values = {}): string {
        return this.translate.instant(`${page}`, values);
    }
}
